(function (global) {
  'use strict';

  function api() {
    return global.DellamodaHandbagEvent || null;
  }

  function write(root, selector, value) {
    var node = root.querySelector(selector);
    if (node) node.textContent = value;
  }

  function writeCountdown(root, distance) {
    var total = Math.max(0, Math.floor(distance / 1000));
    write(root, '[data-days]', String(Math.floor(total / 86400)));
    write(root, '[data-hours]', String(Math.floor(total % 86400 / 3600)).padStart(2, '0'));
    write(root, '[data-minutes]', String(Math.floor(total % 3600 / 60)).padStart(2, '0'));
    write(root, '[data-seconds]', String(total % 60).padStart(2, '0'));
  }

  function validScope(card) {
    var eventApi = api();
    if (!eventApi) return false;
    var products = eventApi.parseIdList(card.dataset.eligibleProductIds);
    var variants = eventApi.parseIdList(card.dataset.eligibleVariantIds);
    var prices = eventApi.parseEligiblePrices(card.dataset.eligiblePrices);
    return card.dataset.store === 'dellamoda' &&
      card.dataset.plannerStatus === 'approved' &&
      card.dataset.visibility === 'public_when_active' &&
      card.dataset.discountStatus !== 'inactive' &&
      card.dataset.eligibilityMatch === 'true' &&
      products.length === 5 &&
      variants.length === 17 &&
      prices.length === 5;
  }

  function activeCard(card, now) {
    var eventApi = api();
    return validScope(card) && eventApi.getWindowState(now, card.dataset.startAt, card.dataset.endAt) === 'active';
  }

  function initialize(root) {
    if (!root || root.dataset.dmHomeEventsInitialized === 'true') return;
    root.dataset.dmHomeEventsInitialized = 'true';
    var allCards = Array.prototype.slice.call(root.querySelectorAll('[data-dm-home-event-card]'));
    var navigation = root.querySelector('[data-dm-home-events-navigation]');
    var dots = root.querySelector('[data-dm-home-events-dots]');
    var activeCards = [];
    var selectedIndex = 0;
    var timer = null;

    function renderSelected() {
      activeCards.forEach(function (card, index) {
        var selected = index === selectedIndex;
        card.hidden = !selected;
        card.setAttribute('aria-hidden', selected ? 'false' : 'true');
      });
      Array.prototype.forEach.call(dots ? dots.querySelectorAll('button') : [], function (dot, index) {
        dot.setAttribute('aria-current', index === selectedIndex ? 'true' : 'false');
      });
    }

    function buildNavigation() {
      if (!navigation || !dots) return;
      dots.textContent = '';
      activeCards.forEach(function (card, index) {
        var dot = global.document.createElement('button');
        dot.type = 'button';
        dot.className = 'dm-home-events__dot';
        dot.setAttribute('aria-label', root.dataset.eventLabel + ' ' + String(index + 1));
        dot.addEventListener('click', function () {
          selectedIndex = index;
          renderSelected();
        });
        dots.appendChild(dot);
      });
      navigation.hidden = activeCards.length < 2;
    }

    function reconcile() {
      var now = Date.now();
      var nextActive = allCards.filter(function (card) { return activeCard(card, now); });
      var changed = nextActive.length !== activeCards.length || nextActive.some(function (card, index) { return card !== activeCards[index]; });
      activeCards = nextActive;
      if (selectedIndex >= activeCards.length) selectedIndex = 0;
      allCards.forEach(function (card) {
        card.hidden = true;
        card.setAttribute('aria-hidden', 'true');
      });
      root.classList.toggle('is-ready', activeCards.length > 0);
      if (changed) buildNavigation();
      if (activeCards.length === 0) return;
      renderSelected();
      activeCards.forEach(function (card) {
        var end = api().parseInstant(card.dataset.endAt);
        if (end !== null) writeCountdown(card, end - now);
      });
    }

    var previous = root.querySelector('[data-dm-home-events-previous]');
    var next = root.querySelector('[data-dm-home-events-next]');
    if (previous) previous.addEventListener('click', function () {
      if (activeCards.length < 2) return;
      selectedIndex = (selectedIndex - 1 + activeCards.length) % activeCards.length;
      renderSelected();
    });
    if (next) next.addEventListener('click', function () {
      if (activeCards.length < 2) return;
      selectedIndex = (selectedIndex + 1) % activeCards.length;
      renderSelected();
    });

    reconcile();
    timer = global.setInterval(reconcile, 1000);
    root.dmHomeEventsDestroy = function () {
      global.clearInterval(timer);
      delete root.dmHomeEventsDestroy;
      delete root.dataset.dmHomeEventsInitialized;
    };
  }

  function initializeAll(container) {
    var scope = container && container.querySelectorAll ? container : global.document;
    Array.prototype.forEach.call(scope.querySelectorAll('[data-dm-home-events]'), initialize);
    if (scope.matches && scope.matches('[data-dm-home-events]')) initialize(scope);
  }

  if (global.document) {
    if (global.document.readyState === 'loading') {
      global.document.addEventListener('DOMContentLoaded', function () { initializeAll(global.document); });
    } else {
      initializeAll(global.document);
    }
    global.document.addEventListener('shopify:section:load', function (event) { initializeAll(event.target); });
    global.document.addEventListener('shopify:section:unload', function (event) {
      Array.prototype.forEach.call(event.target.querySelectorAll('[data-dm-home-events]'), function (root) {
        if (root.dmHomeEventsDestroy) root.dmHomeEventsDestroy();
      });
    });
  }

  global.DellamodaHomeEvents = { activeCard: activeCard, validScope: validScope, initializeAll: initializeAll };
}(typeof window !== 'undefined' ? window : globalThis));
